import { useMemo } from 'react';

export function useHeroMode() {
  return useMemo(() => {
    if (typeof window === 'undefined') return 'immersive';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const lowMem = Boolean(navigator.deviceMemory && navigator.deviceMemory <= 2);
    const saveData = Boolean(navigator.connection && navigator.connection.saveData);
    return reduced || lowMem || saveData ? 'static' : 'immersive';
  }, []);
}
